import React from 'react';
import { v4 } from 'uuid';

const useId = React.useId || function useUuid() {
    /*
     * Utilize useState instead of useMemo because React
     * makes no guarantees that the memo store is durable
     */
    const [id] = React.useState(() => v4());
    return id;
};

export { useId };
